import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';

function HMLSDisclaimer({ className, home, widget }) {
  if (!home.mlsLastModified) {
    return null;
  }

  const disclaimer = widget.disclaimer.replace('{listingModifiedDateTime}', moment(home.mlsLastModified).format('L'));
  return (
    <div className={[className, 'HMLSDisclaimer'].filter(v => v).join(' ')} dangerouslySetInnerHTML={SanitizeHtml(disclaimer)} />
  );
}

HMLSDisclaimer.propTypes = {
  className: PropTypes.string,
  home: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

HMLSDisclaimer.defaultProps = {
  className: undefined,
};

export default withData({
  widget: 'hmls_disclaimer',
})(HMLSDisclaimer);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Disclaimer.js